import { useLayoutEffect, useState } from "react"

import useResizeObserver, {
  UseResizeObserverCallback,
} from "@react-hook/resize-observer"
import { useDebounceCallback } from "usehooks-ts"

export const useContainerSize = (ref: React.RefObject<HTMLElement | null>) => {
  const [size, setSize] = useState<{ height: number; width: number }>({
    width: 0,
    height: 0,
  })
  const headerContainerResizeCallback = useDebounceCallback<UseResizeObserverCallback>(
    (entry) => {
      setSize({ width: entry.target.clientWidth, height: entry.target.clientHeight })
    },
    200,
  )
  useLayoutEffect(() => {
    setTimeout(() => {
      if (ref.current) {
        const sizes = ref.current.getBoundingClientRect()
        setSize({ width: sizes.width, height: sizes.height })
      }
    })
  }, [ref, setSize])
  useResizeObserver(ref, headerContainerResizeCallback)

  return size
}
